module.exports = __webpack_public_path__ + "static/media/Avatar7.a08f4478.png";